import React, {useState} from "react";
// import { DialogTitle, IconButton, DialogActions, DialogContent, Button, Grid } from "@mmaterial-ui/core/";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import CloseIcon from "@mui/icons-material/Close";

import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
/*** components */

import DropdownBox from "../../components/formElements/dropdownBox";
import InputBox from "../../components/formElements/inputBox";

/*** components */

/*** apis */
import postNewSkill from "../../apis/postNewSkill";
import putEditSkill from "../../apis/putEditSkill";
import CircularProgress from '@mui/material/CircularProgress';

/*** api */

const AddSkillForm = (props) => {
  const [apvBtn, setApvBtn] = useState(false);
  const {
    domainOptions,
    onCancel,
    onSave,
    userIdType,
    editSkill,
  } = props;

  let defaultFields = {
    domain: "",
    skill: "",
    isActive: "",
    optionType: "",
    client: {},
  };

  if (editSkill) {
    const {
      client,
      clientId,
      domain,
      domainId,
      id,
      isActive,
      isPrivate,
      name,
    } = editSkill;

    defaultFields = {
      ...defaultFields,
      domain,
      domainId,
      skill: name,
      isActive: isActive.toString(),
      optionType: isPrivate ? "Client-Specific" : "Public",
      client,
      clientId,
      skillId: id,
    };
  }

  const [formFields, setFormFields] = useState(defaultFields);
  const fieldChangeHandler = (field) => (e, val) => {
    const fieldValue = val || e.target.value;
    setFormFields({ ...formFields, [field]: fieldValue });
    if (field === "optionType") {
      setFormFields((prev) => ({ ...prev, client: "" }));
    }
  };

  const cancel = (e) => {
    onCancel && props.onCancel();
  };

  const save = async (e) => {
    setApvBtn(true);
    let response = {};
    const skillData = {
      id: formFields.skillId,
      name: formFields.skill.trim(),
      isPrimary: true,
      updatedBy: userIdType,
      isActive: formFields.isActive === "" ? "" : (formFields.isActive === "true" ? true : false),
      domainId: formFields.domain ? formFields.domain.id : "",
      optionType: formFields.optionType === "Public" ? "Public" : "Private",
    };
    skillData.isPrivate = skillData.optionType === "Private";
    if (skillData.isPrivate) {
      skillData.clientId = formFields.client.id;
    }

    if (
      skillData.name === "" ||
      skillData.domainId === "" ||
      skillData.isActive === ""
    ) {
      setApvBtn(false);
      return NotificationManager.error(
        "Please fill all the mandatory fields",
        "Error",
        10000
      );
    }

    if (skillData.id) {
      try {
        response = await putEditSkill(skillData);

        if (response.data.message?.includes("This Skill name already")) {
          setApvBtn(false);
          return NotificationManager.error(
            "The skill already exists in the system. Please use a different skill name",
            "Error",
            10000
          );
        }
        NotificationManager.success("Skill updated", "Success", 10000);
        setApvBtn(false);
      } catch (e) {
        console.log(e);
        NotificationManager.error("Skill update failed", "Error", 10000);
        setApvBtn(false);
      }
    } else {
      try {
        skillData.createdBy = userIdType;
        response = await postNewSkill(skillData);

        if (response.data.message?.includes("This Skill name already")) {
          setApvBtn(false);
          return NotificationManager.error(
            "The skill already exists in the system. Please use a different skill name",
            "Error",
            10000
          );
        }
        NotificationManager.success("Skill added", "Success", 10000);
        setApvBtn(false);
      } catch (e) {
        console.log(e);
        NotificationManager.error("Skill addition failed", "Error", 10000);
        setApvBtn(false);
      }
    }

    onSave && props.onSave();
  };

  let domainProps = {
    defaultValue: formFields.domain,
    label: "Domain*",
    options: domainOptions,
    getOptionLabel: (option) => (option ? option.name : null),
    placeholder: "Select Domain",
    onChange: fieldChangeHandler("domain"),
  };

  const skillProps = {
    value: formFields.skill,
    label: "Skill*",
    placeholder: "Enter Skill Name",
    onChange: fieldChangeHandler("skill"),
  };

  let isActiveProps = {
    defaultValue: formFields.isActive,
    label: "Is Active*",
    options: ["true", "false"],
    getOptionLabel: (option) =>
      option ? option[0].toUpperCase() + option.substring(1) : null,
    placeholder: "Select Status",
    onChange: fieldChangeHandler("isActive"),
  };

  //TODO add delete skill button on edit skill page
  //TDOD send put request to update skill popularity tables.
  return (
    <>
      <div className='Recruiter_Private_Skill_Modal'>
        <DialogTitle className="admindailog_title_modal_skill">
          {formFields.skillId ? "Edit Skill" : "Add Skill"}
          <IconButton
            aria-label="close"
            style={{
              position: "absolute",
              right: 0,
              top: 0,
              color: "grey",
            }}
            onClick={cancel}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
      </div>
      <DialogContent>
        <DropdownBox {...domainProps} />
        &nbsp;
        <InputBox {...skillProps} />
        &nbsp;
        <DropdownBox {...isActiveProps} />

      </DialogContent>
      <Grid>
        <Grid size={{ xs: 12,md:12}} className="user_pop_button" >
          <DialogActions>
            <Button onClick={cancel} variant="outlined" className="btn3 " color="primary">Cancel</Button>
            <button
              type="button"
              className="btn3 btn_primary ml_5 cp"
              onClick={save}
              disabled={apvBtn}
            >
              <div className="btn_loader">
                Save
                &nbsp;
                {apvBtn &&
                  <div>
                    <CircularProgress size={13} />
                  </div>
                }
              </div>
            </button>
          </DialogActions>
        </Grid>
      </Grid>
      <NotificationContainer />
    </>
  );
};

export default AddSkillForm;
